import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { BusinessTravel } from "../../../../api";

export const businessTravelKeys = {
  items: () => ["businessTravelItems"]
};

export function useGetBusinessTravelItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...businessTravelKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(BusinessTravel.getBusinessTravelItems, params), config);
}

export function useAddBusinessTravelItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(BusinessTravel.addBusinessTravelItems, { questionnaireId, data }), config);
}

export function useUpdateBusinessTravelItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(BusinessTravel.updateBusinessTravelItem, { questionnaireId, recordId, data }), config);
}

export function useDeleteBusinessTravelItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(BusinessTravel.deleteBusinessTravelItem, { questionnaireId, recordId }), config);
}

export function useImportBusinessTravelItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(BusinessTravel.importBusinessTravelItems, { questionnaireId, data }), config);
}

export function useDownloadBusinessTravelTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) =>
    callApi(BusinessTravel.downloadBusinessTravelTemplate, questionnaireId), config);
}